import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const LeadershipTeam = () => {
  return (
    <>
      <SEO 
        title="Leadership Team - Abacies Logiciels"
        description="Meet the leadership team at Abacies Logiciels - experienced executives and technology leaders driving innovation in AI solutions, software development, and digital transformation."
        keywords="leadership team, executives, management, Abacies leadership, technology leaders, company leadership"
      />

      <section className="hero-section">
        <div className="page-container">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-charcoal animate-fade-in">
              Leadership Team
            </h1>
            <p className="text-xl text-titanium leading-relaxed animate-slide-up">
              This is the Leadership Team page with sample content.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="page-container">
          <div className="max-w-4xl mx-auto">
            <p className="text-titanium mb-6">
              Sample content for Leadership Team. This page contains placeholder text and will be updated with actual content.
            </p>
            <Link to="/" className="btn-primary">Return Home</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default LeadershipTeam;
